import { ArrowUpRightIcon } from "@phosphor-icons/react/dist/csr/ArrowUpRight";
import { useId } from "react";
import { Item, ItemContent, ItemMedia } from "@volca/ui/components/ui/item";

interface HarnessChatSuggestedPromptsProps {
  prompts: string[];
  disabled: boolean;
  onSend: (prompt: string) => void;
}

export const HarnessChatSuggestedPrompts = ({
  prompts,
  disabled,
  onSend,
}: HarnessChatSuggestedPromptsProps) => {
  const labelId = useId();

  if (prompts.length === 0) return null;

  return (
    <div>
      <p id={labelId} className="mb-1 text-xs font-medium text-subtle">
        Try asking
      </p>
      {/* Bleeds into the gutter so the prompt text lines up with the label. */}
      <ul aria-labelledby={labelId} className="-mx-2.5 flex flex-col">
        {prompts.map((prompt) => (
          <li key={prompt}>
            <Item
              size="xs"
              render={
                <button
                  type="button"
                  disabled={disabled}
                  onClick={() => onSend(prompt)}
                />
              }
              className="items-start text-left disabled:pointer-events-none disabled:opacity-50"
            >
              <ItemMedia variant="icon">
                <ArrowUpRightIcon aria-hidden className="mt-0.5 text-subtle" />
              </ItemMedia>
              <ItemContent className="min-w-0">{prompt}</ItemContent>
            </Item>
          </li>
        ))}
      </ul>
    </div>
  );
};
